export const menuImageManager = () => {
  const headerElement = document.querySelector('.js-header') as HTMLElement

  const menuElement = document.querySelector('.js-header-menu') as HTMLElement

  const defaultImageWrapper = document.querySelector('.js-header-imageWrapperDefaults') as HTMLElement
  const dynamicImageWrapper = document.querySelector('.js-header-imageWrapperDynamic') as HTMLElement
  const dynamicImageTransitionWrapper = document.querySelector('.js-header-imageWrapperDynamicTransitions') as HTMLElement

  // Kill this if the header element is not found
  if (!headerElement || !defaultImageWrapper || !dynamicImageWrapper || !dynamicImageTransitionWrapper) { return }

  const pageString = menuElement.dataset.pageId as unknown as string
  const pageID = parseInt(pageString)

  let resetTimeTimeout

  const defaultPlacehodler = (defaultImageWrapper.dataset.hasPlaceholder === 'true')
  let placeholderActive = defaultPlacehodler

  const menuLinks = headerElement.querySelectorAll('.js-headerMenuItem') as unknown as HTMLElement[]

  menuLinks.forEach(link => {
    link.addEventListener('mouseenter', () => {
      const linkString = link.dataset.itemId as unknown as string
      const linkID = parseInt(linkString)

      if (linkID !== pageID) {
        clearTimeout(resetTimeTimeout)
      }

      const imageLinks = link.dataset.imageList as unknown as string
      const formattedImageLinks = JSON.parse(imageLinks) as string[]

      const hasPlaceholder = (link.dataset.hasPlaceholder === 'true')

      if (placeholderActive && hasPlaceholder) {
        return
      }

      if (hasPlaceholder) {
        placeholderActive = true
      }

      if (!hasPlaceholder) {
        placeholderActive = false
      }

      if (linkID !== pageID) {
        while (dynamicImageTransitionWrapper.childNodes.length > 0) {
          dynamicImageWrapper.appendChild(dynamicImageTransitionWrapper.childNodes[0])
        }

        defaultImageWrapper.classList.add('-fadeout')
        dynamicImageWrapper.classList.add('-fadeout')
        dynamicImageTransitionWrapper.classList.add('-fadeout')

        dynamicImageTransitionWrapper.innerHTML = ''

        for (const link of formattedImageLinks) {
          const img = document.createElement('img')
          img.src = link
          dynamicImageTransitionWrapper.appendChild(img)
          img.addEventListener('transitionend', () => {
            dynamicImageWrapper.appendChild(img)
          })
        }

        setTimeout(() => {
          dynamicImageWrapper.innerHTML = ''
          dynamicImageWrapper.classList.remove('-fadeout')
          dynamicImageTransitionWrapper.classList.remove('-fadeout')
        }, 150)
      }
    })

    link.addEventListener('mouseleave', () => {
      const linkString = link.dataset.itemId as unknown as string
      const linkID = parseInt(linkString)

      if (linkID !== pageID) {
        resetTimeTimeout = setTimeout(() => {
          defaultImageWrapper.classList.remove('-fadeout')
          dynamicImageWrapper.classList.add('-fadeout')
          dynamicImageTransitionWrapper.classList.add('-fadeout')
        }, 300)
      }
    })
  })
}
